module.exports = {"required":"This field is required","unauthorized":"You are unauthorized","invalid":"Your input is invalid"}


//////////////////
// WEBPACK FOOTER
// ./src/lang/en/error/index.json
// module id = UA8C
// module chunks = 58